import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import LabelInput from '../../../form/component/LabelInput'
import TextArea from '../../../form/component/TextArea'
import RelationShip from './RelationShip'
import Midline from './Midline'


const ExistingCondition = ({ existingCondition, changeExistingCondition, readOnly, saveTreatmentPlan }) => {
    return (
        <div className="existing-condition">
            <ContentBox title="Existing Condition">
                <Row>
                    <Column size={12}>
                        <LabelInput label="Chief complaint">
                            <TextArea
                                name="chiefComplaint"
                                object={existingCondition}
                                readOnly={readOnly}
                                onChange={changeExistingCondition}
                                onBlur={saveTreatmentPlan}/>
                        </LabelInput>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={6}>
                        <Midline existingCondition={existingCondition}
                            changeExistingCondition={changeExistingCondition}
                            valuePrefix="upper"
                            readOnly={readOnly}
                            saveTreatmentPlan={saveTreatmentPlan}
                            title="Upper midline"/>
                    </Column>
                    <Column size={6}>
                        <Midline existingCondition={existingCondition}
                            changeExistingCondition={changeExistingCondition}
                            valuePrefix="lower"
                            readOnly={readOnly}
                            saveTreatmentPlan={saveTreatmentPlan}
                            title="Lower midline"/>
                    </Column>
                </Row>
                <Row top="M">
                    <Column size={6}>
                        <RelationShip
                            title="Canine relationship"
                            changeExistingCondition={changeExistingCondition}
                            existingCondition={existingCondition}
                            leftValue="canineRelationshipLeft"
                            rightValue="canineRelationshipRight"
                            saveTreatmentPlan={saveTreatmentPlan}
                            readOnly={readOnly}
                        />

                    </Column>
                    <Column size={6}>
                        <RelationShip
                            title="Molar relationship"
                            changeExistingCondition={changeExistingCondition}
                            existingCondition={existingCondition}
                            leftValue="molarRelationshipLeft"
                            rightValue="molarRelationshipRight"
                            saveTreatmentPlan={saveTreatmentPlan}
                            readOnly={readOnly}
                        />
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}

ExistingCondition.propTypes = {
    existingCondition: PropTypes.object.isRequired,
    changeExistingCondition: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    saveTreatmentPlan: PropTypes.func.isRequired,
}


export default ExistingCondition



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/ExistingCondition.js